module.exports = __webpack_public_path__ + "img/f388062b951de4e5f7b687f19e8c4c8d.cce72724.png";